import axios from 'axios'
import store from './store'

console.log(location.protocol, process.env)
let baseUrlAxios = location.protocol + '//' + process.env.django_url
let dictAxios = {
  baseURL: baseUrlAxios
}
console.log(baseUrlAxios)
const instance = axios.create(
  dictAxios
)

instance.interceptors.response.use((response) => {
  return response
}, function (error) {
  // Do something with response error

  if (error.response && error.response.status === 400) {
    console.log('unauthorized, logging out ...')
    store.dispatch('storeErrors', 'Wrong authentication')
  }
  return Promise.reject(error.response)
})

export default instance



// WEBPACK FOOTER //
// ./src/axios-auth.js